import { h } from 'hyperapp';
import cc from 'classcat';
import './index.less';
import Close from '~/common/account/components/close.jsx';
import Avatar from '~/common/account/components/avatar.jsx';
import Title from '~/common/account/components/title.jsx';
import FieldEmail from '~/common/account/components/field-email.jsx';
import FieldCaptcha from '~/common/account/components/field-captcha.jsx';
import FieldEmailCode from '~/common/account/components/field-email-code.jsx';
import FieldName from '~/common/account/components/field-name.jsx';
import FieldPassword from '~/common/account/components/field-password.jsx';
import SendActions from './components/send-actions.jsx';
import RegisterActions from './components/register-actions.jsx';
export default (({
  state,
  actions
}) => h("div", {
  oncreate: element => actions.onCreate({
    element
  }),
  key: "register",
  class: "mc-account mc-register mdui-dialog"
}, h(Close, {
  onClick: state.email_valid ? actions.prevStep : actions.close,
  icon: state.email_valid ? 'arrow_back' : 'close'
}), state.email_valid ? h(Avatar, null) : null, h(Title, {
  text: state.email_valid ? state.email : '创建新账号'
}), h("form", {
  onsubmit: actions.nextStep,
  class: cc([{
    'mdui-hidden': state.email_valid
  }]),
  key: "send"
}, h(FieldEmail, {
  value: state.email,
  message: state.email_msg,
  onInput: actions.onInput
}), h(FieldCaptcha, {
  value: state.captcha_code,
  message: state.captcha_code_msg,
  image: state.captcha_image,
  hide: !state.captcha_token,
  onInput: actions.onInput,
  onRefresh: actions.refreshCaptcha
}), h(FieldEmailCode, {
  value: state.email_code,
  message: state.email_code_msg,
  sending: state.sending,
  show_resend_countdown: state.show_resend_countdown,
  resend_countdown: state.resend_countdown,
  onInput: actions.onInput,
  onSend: actions.sendEmail
}), h(SendActions, {
  state: state,
  actions: actions
})), h("form", {
  onsubmit: actions.register,
  class: cc([{
    'mdui-hidden': !state.email_valid
  }]),
  key: "submit"
}, h(FieldName, {
  value: state.username,
  message: state.username_msg,
  label: "\u7528\u6237\u540D",
  name: "username",
  error: state.username_msg || '用户名不能为空',
  onInput: actions.onInput
}), h(FieldPassword, {
  value: state.password,
  message: state.password_msg,
  label: "\u5BC6\u7801",
  name: "password",
  onInput: actions.onInput
}), h(RegisterActions, {
  state: state
}))));